import { dynamicImport } from '@core/helpers'
import logger from '@logger'
import { ROUTES } from '@router'

export default () => {
  const resolutionFlowRoute = [
    {
      path: 'dashboard/resolution/new/:orderlineId/:customerIssues',
      name: ROUTES.DASHBOARD.RESOLUTION.SELF_FROM_DIAGNOSIS_V2,
      component: () => dynamicImport(import('@diagnosis/ResolutionFlow')),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Contact form confirmation (remote assistance), with the legacy `customerRequestId`
    {
      path: 'dashboard/claim/confirmation/:customerRequestId?',
      name: ROUTES.DASHBOARD.RESOLUTION.CONTACT_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@diagnosis/ResolutionFlow/ContactConfirmationPage.vue'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Contact form confirmation (remote assistance)
    {
      path: 'dashboard/resolution/confirmation/:resolutionId?',
      name: ROUTES.DASHBOARD.RESOLUTION.RESOLUTION_CONTACT_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@diagnosis/ResolutionFlow/ContactConfirmationPage.vue'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Return funnel confirmation, with the legacy `customerRequestId`
    {
      path: 'dashboard/claim/return/confirmation/:customerRequestId',
      name: ROUTES.DASHBOARD.RESOLUTION.RETURN_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@diagnosis/ResolutionFlow/ReturnConfirmationPage.vue'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // Return funnel confirmation
    {
      path: 'dashboard/resolution/return/confirmation/:resolutionId',
      name: ROUTES.DASHBOARD.RESOLUTION.RESOLUTION_RETURN_CONFIRMATION,
      component: () =>
        dynamicImport(
          import('@diagnosis/ResolutionFlow/ReturnConfirmationPage.vue'),
        ),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    // After launch of Diagno v2 there were still customers coming to this route
    // from Diagno v1 or old links. We deal with these gracefully by sending
    // them into Diagno v2.
    {
      path: 'dashboard/claim/new/:orderlineId/:tilesIds',
      name: ROUTES.DASHBOARD.RESOLUTION.SELF,
      redirect: () => {
        logger.info('[ResolutionFlow] Redirect: Resolutionflow v1 -> Diagno v2')

        return 'dashboard/diagnosis/new/:orderlineId'
      },
    },
    {
      path: 'dashboard/diagnosis/new/:orderlineId',
      name: ROUTES.DASHBOARD.DIAGNOSIS.SELF,
      component: () =>
        dynamicImport(import('@diagnosis/DiagnosisFlow/DiagnosisFlow.vue')),
      meta: {
        auth: {
          required: true,
        },
      },
    },
  ]

  return resolutionFlowRoute
}
